/* global swal:false */
(function() {
  'use strict';

  angular
    .module('admin.users.details.ledgers', ['admin.users.details.ledgers.bundles'])
    .controller('LedgersAdminCtrl', LedgersAdminCtrl);

  /** @ngInject */
  function LedgersAdminCtrl($scope, $stateParams, $state, UsersService, UploadService) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;
    vm.totalUsers = 0;
    vm.usersPerPage = 25;
    vm.oldPage = 0;
    vm.currentPage = 25;
    vm.first = true;
    vm.totalItems = 0;
    vm.pagination = {
      current: 1
    };
    vm.balance = 0;
    vm.balancePage = [{},{
      page: 1,
      balance: vm.balance
    }];
    vm.pageNow = 1;
    vm.isSame = {is: false, index: 0};
    vm.currentFilter = 'All';

    vm.sortType = 'ts-m-desc';
    vm.sortReverse = false;

    vm.filter = 'All';
    vm.sort = [
      'All',
      'All Coins In',
      'All Coins Out',
      'Purchased',
      'Claimed',
      'Tap Joy',
      'Facebook',
      'Invitee',
      'Inviter',
      'Joined',
      "Editor's choice",
      'Bundles',
      'VIP',
      'Bundle Award',
      'Fyber',
      'Promo Coin Claim',
      'Challenge Award',
      'Listing Sale',
      'Listing Purchase',
      'Coin Reward',
      'Coin Award',
      'Coin Purchase Refund',
      'Cash Coin Purchases'
    ];

    vm.sortBy = function(item, pageNumber){
      vm.totalItems = 0;
      vm.currentFilter = item;

      if (pageNumber !== undefined) {
        vm.pageNow = pageNumber;
      } else {
        vm.pageNow = 1;
      }

      switch(item){
        case 'All':
          load(vm.pageNow);
          break;
        case 'All Coins In':
          load(vm.pageNow, undefined, 'in');
          break;
        case 'All Coins Out':
          load(vm.pageNow, undefined, 'out');
          break;
        case 'Purchased':
          load(vm.pageNow, 2);
          break;
        case 'Claimed':
          load(vm.pageNow, 1);
          break;
        case 'Tap Joy':
          load(vm.pageNow, 6);
          break;
        case 'Facebook':
          load(vm.pageNow, 10);
          break;
        case 'Invitee':
          load(vm.pageNow, 9);
          break;
        case 'Inviter':
          load(vm.pageNow, 8);
          break;
        case 'Joined':
          load(vm.pageNow, 7);
          break;
        case "Editor's choice":
          load(vm.pageNow, 3);
          break;
        case 'Bundles':
          load(vm.pageNow, 5);
          break;
        case 'VIP':
          load(vm.pageNow, 11);
          break;
        case 'Bundle Award':
          load(vm.pageNow, 12);
          break;
        case 'Fyber':
          load(vm.pageNow, 13);
          break;
        case 'Promo Coin Claim':
          load(vm.pageNow, 14);
          break;
        case 'Challenge Award':
          load(vm.pageNow, 15);
          break;
        case 'Listing Sale':
          load(vm.pageNow, 16);
          break;
        case 'Listing Purchase':
          load(vm.pageNow, 17);
          break;
        case 'Coin Reward':
          load(vm.pageNow, 19);
          break;
        case 'Coin Award':
          load(vm.pageNow, 20);
          break;
        case 'Coin Purchase Refund':
          load(vm.pageNow, 21);
          break;
        case 'Cash Coin Purchase':
          load(vm.pageNow, 22);
          break;
      }
    };

    UsersService.get($stateParams.parentId).then(function(result){
      vm.user = result.results;
    });

    load(1);

    var oldSortType;
    function load(pageNumber, filter, flow){
      vm.balance = 0;
      if (pageNumber === 1) {
        vm.pagination.current = 1;
        vm.balance = 0;
      }

      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      }
      else {
        vm.first = false;
      }

      oldSortType = angular.copy(vm.sortType);
      if (flow === undefined) {
        if (filter !== undefined) {
          UsersService.listLedgersFilter($stateParams.parentId, filter, vm.oldPage, 25, vm.sortType).then(success);
        } else {
          UsersService.listLedgers($stateParams.parentId, vm.oldPage, 25, vm.sortType).then(success);
        }
      } else {
         UsersService.listLedgersFlow($stateParams.parentId, flow, vm.oldPage, 25, vm.sortType).then(success);
      }


      function success(result){
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }

        for (var i = 0; i < result.results.length; i++) {
          switch (result.results[i].k) {
            case 1:
              result.results[i].kname = 'Free Coins Claimed';
              break;
            case 2:
              result.results[i].kname = 'Coin Purchase';
              break;
            case 3:
              result.results[i].kname = 'Admin Adjustment';
              break;
            case 4:
              result.results[i].kname = 'User Gift';
              break;
            case 5:
              result.results[i].kname = 'Bundle Purchase';
              break;
            case 6:
              result.results[i].kname = 'TapJoy';
              break;
            case 7:
              result.results[i].kname = 'Initial Signup';
              break;
            case 8:
              result.results[i].kname = 'Reward Inviter';
              break;
            case 9:
              result.results[i].kname = 'Reward Invitee';
              break;
            case 10:
              result.results[i].kname = 'Add Facebook';
              break;
            case 11:
              result.results[i].kname = 'VIP';
              break;
            case 12:
              result.results[i].kname = 'Bundle Award';
              break;
            case 13:
              result.results[i].kname = 'Fyber';
              break;
            case 14:
              result.results[i].kname = 'Promo Coin Claim';
              break;
            case 15:
              result.results[i].kname = 'Challenge Award';
              break;
            case 16:
              result.results[i].kname = 'Listing Sale';
              break;
            case 17:
              result.results[i].kname = 'Listing Purchase';
              break;
            case 19:
              result.results[i].kname = 'Coin Reward';
              break;
            case 20:
              result.results[i].kname = 'Coin Award';
              break;
            case 21:
              result.results[i].kname = 'Coin Purchase Refund';
              break;
            case 22:
              result.results[i].kname = 'Cash Coin Purchase';
              break;
            default:
              result.results[i].kname = 'Unknown';
              break;
          }

          result.results[i].ts = new Date(parseInt(result.results[i].ts.toString().substring(0, result.results[i].ts.toString().length - 3)));
          result.results[i]['ts-m'] = new Date(parseInt(result.results[i]['ts-m'].toString().substring(0, result.results[i]['ts-m'].toString().length - 3)));
          if (vm.balance === 0) {
            vm.balance = result.results[i].c;
            if (result.results[i].c > 0) {
              result.results[i].in = result.results[i].c;
              result.results[i].out = "";
            } else {
              result.results[i].in = "";
              result.results[i].out = result.results[i].c;
            }

          } else {
            if (result.results[i].c > 0) {
              result.results[i].in = result.results[i].c;
              result.results[i].out = "";
              vm.balance = vm.balance + result.results[i].c;
            } else if (result.results[i].k !== 5) {
              result.results[i].out = result.results[i].c;
              result.results[i].in = "";
              vm.balance = vm.balance + result.results[i].c;
            } else {
              result.results[i].out = result.results[i].c;
              result.results[i].in = "";
              vm.balance = vm.balance + result.results[i].c;
            }
          }

          result.results[i].balance = vm.balance;
        }

        vm.items = result.results;
      }
    }

    vm.pageChanged = function(newPage) {
      vm.sortType = oldSortType;
      vm.sortBy(vm.currentFilter, newPage);
    };

    vm.bp = function(item) {
      if (item.bp !== null) {
        $state.go('admin.users.details.ledgers.bundles', {bpId: item.bp.id, bundleId: item.bp.b.id, setId: item.bp.b['id-s']});
      }
    };

    vm.sortFilter = function(type){
      vm.sortReverse = !vm.sortReverse;
      if (vm.sortReverse) {
        vm.sortType = type + '-asc';
      } else {
        vm.sortType = type + '-desc';
      }
      vm.sortBy(vm.currentFilter, vm.pagination.current);
    };

  }

})();
